"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const utils_1 = require("@loadsure/utils");
class PercentageCommission {
    constructor(value, partnerId) {
        this.value = value;
        this.partnerId = partnerId;
        this.type = types_1.eCommissionType.PERCENTAGE;
        if (value < 0) {
            throw new Error("Commission percentage cannot be negative");
        }
        this.percentage = value / 100;
    }
    calculate(baseAmount) {
        if (baseAmount < 0 || Number.isNaN(baseAmount)) {
            throw new Error("Base amount must be a positive number");
        }
        return utils_1.roundToDecimals(baseAmount * this.percentage);
    }
    get isZero() {
        return this.value === 0;
    }
    get description() {
        return `${this.value}% of Premium`;
    }
}
exports.default = PercentageCommission;
//# sourceMappingURL=percentageCommission.class.js.map